import { create } from "zustand";
import {
  ActivityContext,
  ActivityItem,
  ActivityItems,
} from "./activityItemContext.types";

export const useActivityItemContext = create<ActivityContext<ActivityItem>>(
  (commit) => ({
    activityItems: [],
    filteredActivityItems: [],
    currentActivity: null,
    isLoading: false,
    isRefetching: false,

    setActivityItems: (items: ActivityItems) =>
      commit({ activityItems: items }),
    setFilteredActivityItems: (items: ActivityItems) =>
      commit({ filteredActivityItems: items }),
    selectActivity: (activity: ActivityItem) =>
      commit({ currentActivity: activity }),
    setLoading: (loading: boolean) => commit({ isLoading: loading }),
    setRefetching: (refetching: boolean) =>
      commit({ isRefetching: refetching }),
  })
);
